import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import parse from 'html-react-parser';
import template from './cta-3.twig';
import { useWistia } from '@miro-site/core';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var Cta3 = function Cta3(props) {
  var _props$video;

  useWistia((_props$video = props.video) === null || _props$video === void 0 ? void 0 : _props$video.id);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: parse(template(_objectSpread(_objectSpread({}, props), {}, {
      component_name: 'CTA Section',
      ctf_assets: 'images.ctfassets.net'
    })))
  });
};

export default Cta3;